module.exports = __webpack_public_path__ + "static/media/camarj.3fee9710.svg";